export default class resize {
    constructor(){
    }
    set(){
        let _w = window.innerWidth;
        let _h = window.innerHeight;

        let _width,_height,_top,_left;

        /* 画面サイズを元に一旦サイズを算出 */
        if(_w > _h){
            _width = _w;
            _height = _w * (1080/1920);


            /* 画面サイズに対してサイズが足りてないかチェック */
            if(_h>_height){
                _width = _width * (_h / _height);
                _height = _h;
            }
            _top = (_h - _height) / 2;
            _left = (_w - _width) / 2;

        }else{
            _width = _h * (1920/1080);
            _height = _h;

            /* 画面サイズに対してサイズが足りてないかチェック */
            if(_w>_width){
                _height = _height * (_w / _width);
                _width = _w;
            }
            _top = (_h - _height) / 2;
            _left = (_w - _width) / 2;

        }

        TweenMax.set($(".js__resize-full"),{
            width:_width,
            height:_height,
            x:_left,
            y:_top
        });

        if(Useragnt.tablet) {
            TweenMax.set($('.l-section__full-pc,.l-section__half-pc'), {
                height: _h
            });
        }
    }
}

